import styled from "@emotion/styled";
import React from "react";
import { Geo } from "../messages";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { AppButton } from "./Generic/AppButton";
import { AppAbstractModal } from "./Generic/AppModal/AppAbstractModal";
import { AppOverlay } from "./Generic/AppOverlay";
import MapWithLocationsCenter from "./MapWithLocationsCenter";

export interface PromptCaregiverLocationTooFarProps {
  isOpen: boolean;
  isClockIn: boolean;
  caregiverLocation: Geo;
  visitLocation: Geo;
  patientInitials: string;
  onRequestClose: () => void;
  onClockInOut: () => void;
}

const PromptCaregiverLocationTooFarModal = (props: PromptCaregiverLocationTooFarProps) => {
  return (
    <AppOverlay>
      <PromptCaregiverLocationTooFarModal.Root
        isOpen={props.isOpen}
        onRequestClose={props.onRequestClose}
      >
        <PromptCaregiverLocationTooFarModal.Map>
          <MapWithLocationsCenter
            caregiverLocation={props.caregiverLocation}
            visitLocation={props.visitLocation}
            patientInitials={props.patientInitials}
          />
        </PromptCaregiverLocationTooFarModal.Map>
        <PromptCaregiverLocationTooFarModal.Title>
          {translate(STRINGS.LOOKS_LIKE_YOU_ARE_TOO_FAR_FROM_THE_VISITS_LOCATION)}
        </PromptCaregiverLocationTooFarModal.Title>
        <PromptCaregiverLocationTooFarModal.Message>
          {translate(STRINGS.CLOCKING_IN_OUT_NOT_IN_THE_VISITS_LOCATION_CAN_CAUSE_ISSUES)}
        </PromptCaregiverLocationTooFarModal.Message>
        <PromptCaregiverLocationTooFarModal.Buttons>
          <AppButton variant="filled" color="primary" onClick={props.onRequestClose}>
            {translate(STRINGS.OK_ILL_TRY_LATER)}
          </AppButton>
          <AppButton variant="link" color="black" onClick={props.onClockInOut}>
            {props.isClockIn
              ? translate(STRINGS.I_WANT_TO_CLOCK_IN_ANYWAY)
              : translate(STRINGS.I_WANT_TO_CLOCK_OUT_ANYWAY)}
          </AppButton>
        </PromptCaregiverLocationTooFarModal.Buttons>
      </PromptCaregiverLocationTooFarModal.Root>
    </AppOverlay>
  );
};

PromptCaregiverLocationTooFarModal.Root = styled(AppAbstractModal)`
  > .container {
    background-color: #fff;
    border-radius: 24px;
    box-sizing: border-box;
    padding: 32px 32px 4px 32px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    text-align: center;
    max-height: 90vh;
  }
`;

PromptCaregiverLocationTooFarModal.Title = styled.div`
  font-size: 20px;
  font-weight: 700;
  text-align: initial;
  margin-top: 20px;
`;

PromptCaregiverLocationTooFarModal.Message = styled.div`
  font-size: 14px;
  font-weight: 600;
  margin-top: 8px;
  text-align: initial;
`;

PromptCaregiverLocationTooFarModal.Buttons = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;
PromptCaregiverLocationTooFarModal.Map = styled.div`
  border-radius: 16px;
  overflow: hidden;
  height: 200px;
`;

export default PromptCaregiverLocationTooFarModal;
